
import { Component, Vue } from 'vue-property-decorator';
import GtrCourseProgress from '@/modules/common/components/ui-core/gtr-course-progress/gtr-course-progress.vue'
import GtrCourseContents from '@/modules/common/components/ui-core/gtr-course-contents/gtr-course-contents.vue'
import { mapState } from 'vuex'

@Component({
  components: { GtrCourseProgress, GtrCourseContents },
  computed: {
    ...mapState('auth', ['participant']),
    ...mapState('learning', ['course'])
  }
})
export default class DashboardView extends Vue {
  participant!: any;
  course!: any;

  get participantName () {
    return this.participant?.participant_data?.full_name || ''
  }

  get courseName () {
    return this.course?.name || 'Course'
  }
  get courseCeuPoints () {
    return this.course?.ceu_point?.points || null
  }

  get courseCeuPointType () {
    return this.course?.ceu_point?.ceu?.name || 'CEU'
  }

  get courseCertificateName () {
    return this.course?.certificate?.name || null
  }

  get courseCompleted () {
    return this.participant?.participant_data?.course_progress?.completed || false
  }

  get LmsCertificateUrl () {
    return this.participant?.participant_data?.lms_certificate_url || null
  }
}
